@if (showCameraPopUp) {
  <kx-camera-audio-permssion [device]="device" [resource]="resourceName"
  (closedevicePopup)="closedevicePopup($event)"></kx-camera-audio-permssion>
}

@if (faceImgCapture !=undefined && faceImgCapture) {
  <div id="video-container">
    <video id="video" style="display: none;" autoplay></video>
    <canvas id="canvas"></canvas>
  </div>
}